<template>
  <div id="app" :class="className">
    <Particles :animateStep="animateStep" />
    <router-view :animateStep="animateStep" />
    <footer :class="footerClassName">
      <p :class="copyClassName">
        &copy; VirtualCast, Inc. All rights reserved.
      </p>
      <ul :class="shareClassName">
        <li class="share_head">SHARE</li>
        <li>
          <button @click="twitterShare(message, siteUrl, hashTag)">
            <img src="./assets/icon_twitter.svg" alt="Twitter" role="button" />
          </button>
        </li>
        <li>
          <button @click="facebookShare(message, siteUrl)">
            <img
              src="./assets/icon_facebook.svg"
              alt="Facebook"
              role="button"
            />
          </button>
        </li>
        <li>
          <button @click="lineShare(message, siteUrl)">
            <img src="./assets/icon_line.svg" alt="Twitter" role="button" />
          </button>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import Particles from "./components/atoms/TheParticles";
export default {
  name: "App",
  components: { Particles },
  data() {
    return {
      message:
        "‪バーチャルキャストでバーチャルマーケット4連動イベント開催！最新のVR内購入機能を先行体験して、魅力的な商品を手にしよう！",
      hashTag: "Vケット4,Vキャス会場",
      siteUrl: "https://corp.virtualcast.jp/vmarket4th",
      animateStep: 0,
      timer: null
    };
  },
  computed: {
    className: function() {
      return "animate_step_" + this.animateStep;
    },
    footerClassName: function() {
      return this.animateStep > 1 ? "animated" : "";
    },
    copyClassName: function() {
      return this.animateStep > 3 ? "copy animated" : "copy";
    },
    shareClassName: function() {
      return this.animateStep > 3 ? "share animated" : "share";
    }
  },
  methods: {
    // デモ用のオートタイマー
    ticker() {
      this.timer = setTimeout(() => {
        if (this.animateStep < 4) {
          this.animateStep++;
          this.ticker();
        } else {
          clearTimeout(this.timer);
        }
      }, 500);
    },
    twitterShare: (_msg, _url, _hashtag) => {
      const url =
        `https://twitter.com/intent/tweet?text=` +
        _msg +
        `&url=` +
        _url +
        `&hashtags=` +
        _hashtag;
      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(url, "twitter", option);
    },
    facebookShare: (_msg, _url) => {
      const url = `http://www.facebook.com/share.php?u=` + _url + `&t=` + _msg;
      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(url, "twitter", option);
    },
    lineShare: (_msg, _url) => {
      const url = `http://line.me/R/msg/text` + _msg + `/?` + _url ;
      const option = "status=1,width=818,height=400,top=100,left=100";
      window.open(url, "twitter", option);
    }
  },
  mounted() {
    this.ticker();
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@900&display=swap");
html {
  min-height: 100%;
}
body {
  min-height: 100%;
  margin: 0;
  background: #0aa0fd url("./assets/bg.png") no-repeat fixed 0 0;
  background-size: cover;
  color: #fff;
  font-family: "Noto Sans JP", sans-serif;
}
body.animated {
  overflow: hidden;
}
footer {
  overflow: hidden;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;

  transition: all 0.4s;
  opacity: 0;
}
footer.animated {
  opacity: 1;
}
.copy {
  position: absolute;
  font-family: "Montserrat", "Avenir", Helvetica, Arial, sans-serif;
  font-style: italic;
  font-weight: bold;
  font-size: 12px;
  right: 0;
  margin: 50px 0 0;
  padding: 5rem 0 0;
  transform-origin: right;
  transform: rotate(90deg);
  color: #fff;
  top: 50%;
  z-index: 10;

  transition: all 0.4s;
  opacity: 0;
}
.copy.animated {
  opacity: 1;
}
.share {
  position: absolute;
  left: 0;
  color: #fff;
  top: 50%;
  margin: -110px 0 0;
  padding: 0 0 0 2vw;
  align-items: center;
  display: flex;
  list-style: none;
  flex-direction: column;
  z-index: 10;

  transition: all 0.4s;
  opacity: 0;
}
.share.animated {
  opacity: 1;
}
.share_head {
  font-family: "Montserrat", "Avenir", Helvetica, Arial, sans-serif;
  font-style: italic;
  font-weight: bold;
  font-size: 12px;
  margin: 1rem 0;
  padding: 1rem 0;
  transform: rotate(90deg);
}

footer li {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 6px 0;
  padding: 0;
  line-height: 1;
}
footer li button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: 21px;
  height: 21px;
  cursor: pointer;
}
footer li a {
  display: block;
  width: 21px;
  height: 21px;
}
#app {
  min-height: 100%;
  font-family: "Noto Sans CJK JP", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
#app.animate_step_4 {
  overflow: inherit;
}
.g_section {
  width: 100%;
  max-width: 1185px;
  padding: 8rem 60px;
  box-sizing: border-box;
  text-align: left;
  position: relative;
}
.g_section.pt-0 {
  padding-top: 0;
}
.g_section.pb-0 {
  padding-bottom: 0;
}
.g_bg_text {
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
}
.g_bg_text.opposite {
  left: 0;
  right: auto;
}
.g_frame {
  border: 1px solid #fff;
  padding: 40px;
  max-width: 1024px;
  box-sizing: border-box;
  background: rgba(3, 1, 116, 0.2);
  position: relative;
}
.g_frame img {
  vertical-align: middle;
}
.g_hd_ja_wrap {
  text-align: left;
  margin: 0 0 2rem;
}
.g_hd_ja {
  font-size: 2.5rem;
  line-height: 1;
  margin: 0;
  font-weight: 900;
  font-feature-settings: "palt";
}
.g_hd_en_wrap {
  text-align: left;
  margin: 0 0 0.5rem;
}
.g_hd_en {
  font-size: 0.75rem;
  margin: 0;
  text-align: left;
  font-family: "Montserrat", "Avenir", Helvetica, Arial, sans-serif;
  font-weight: bold;
  font-style: italic;
}
.g_link_button {
  background: #fff;
  color: #1154ee;
  font-weight: 900;
  text-align: center;
  display: block;
  text-decoration: none;
  position: relative;
  padding: 1rem;
  font-size: 1.5rem;
  line-height: 1;
  font-feature-settings: "palt";
}
.g_link_button:after {
  content: "";
  display: block;
  background: url("./assets/icon_caret.svg") no-repeat 50% 50%;
  width: 1rem;
  height: 1rem;
  position: absolute;
  right: 1rem;
  top: 50%;
  margin: -0.5rem 0 0;
}
.g_ui_md {
  display: none;
}
@media screen and (max-width: 1200px) {
  .g_section {
    padding: 8rem 5%;
  }
}
@media screen and (max-width: 1110px) {
  .g_ui_md {
    display: inherit;
  }
}
@media screen and (max-width: 768px) {
  .g_link_button {
    font-size: 1.15rem;
  }
}
@media screen and (max-width: 578px) {
  footer {
    display: none;
  }
  footer p {
    padding: 0 0 0 20px;
    font-size: 10px;
  }
  footer ul {
    padding: 10px 14px;
  }
  .g_link_button {
    font-size: 1rem;
  }
  .g_link_button:after {
    right: 0.5rem;
  }
  .g_hd_ja {
    font-size: 2rem;
  }
  .g_section {
    padding: 3rem 5%;
  }
  .g_frame {
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue